import { Color, ColorBorder, ColorVariants } from '@/constants/color';

export const buttonBaseClasses =
  'font-semibold text-center transition duration-200 ease-in shadow-sm focus:outline-hidden focus:ring-2 focus:ring-offset-2';
export const buttonSizeVariants = {
  badge: 'text-xs px-2 py-0.5 leading-4 !rounded-full font-bold capitalize shadow-xs',
  xs: 'text-xs px-2 py-1',
  sm: 'text-sm px-3 py-2',
  base: 'text-base px-4 py-2',
  lg: 'text-lg px-5 py-3',
  xl: 'text-xl px-6 py-4'
};

export const buttonColorVariants: { [key in Color]: string } = {
  [Color.AMBER]: `${ColorVariants[Color.AMBER]} ${
    ColorBorder[Color.AMBER]
  } focus:ring-amber-500 hover:bg-amber-700`,
  [Color.BLACK]: `${ColorVariants[Color.BLACK]} ${
    ColorBorder[Color.BLACK]
  } focus:ring-black-700 hover:bg-black-700`,
  [Color.BLUE]: `${ColorVariants[Color.BLUE]} ${
    ColorBorder[Color.BLUE]
  } focus:ring-blue-500 hover:bg-blue-700`,
  [Color.CYAN]: `${ColorVariants[Color.CYAN]} ${
    ColorBorder[Color.CYAN]
  } focus:ring-cyan-500 hover:bg-cyan-700`,
  [Color.EMERALD]: `${ColorVariants[Color.EMERALD]}  ${
    ColorBorder[Color.EMERALD]
  } focus:ring-emerald-500 hover:bg-emerald-700`,
  [Color.GRAY]: `${ColorVariants[Color.GRAY]} ${
    ColorBorder[Color.GRAY]
  } focus:ring-gray-500 hover:bg-gray-700`,
  [Color.GREEN]: `${ColorVariants[Color.GREEN]} ${
    ColorBorder[Color.GREEN]
  } focus:ring-green-500 hover:bg-green-700`,
  [Color.INDIGO]: `${ColorVariants[Color.INDIGO]} ${
    ColorBorder[Color.INDIGO]
  } focus:ring-indigo-500 hover:bg-indigo-700`,
  [Color.LIME]: `${ColorVariants[Color.LIME]} ${
    ColorBorder[Color.LIME]
  } focus:ring-lime-500 hover:bg-lime-700`,
  [Color.NEUTRAL]: `${ColorVariants[Color.NEUTRAL]} ${
    ColorBorder[Color.NEUTRAL]
  } focus:ring-neutral-500 hover:bg-neutral-700`,
  [Color.ORANGE]: `${ColorVariants[Color.ORANGE]} ${
    ColorBorder[Color.ORANGE]
  } focus:ring-orange-500 hover:bg-orange-700`,
  [Color.RED]: `${ColorVariants[Color.RED]} ${
    ColorBorder[Color.RED]
  } focus:ring-red-500 hover:bg-red-700`,
  [Color.SKY]: `${ColorVariants[Color.SKY]} ${
    ColorBorder[Color.SKY]
  } focus:ring-sky-500 hover:bg-sky-700`,
  [Color.SLATE]: `${ColorVariants[Color.SLATE]} ${
    ColorBorder[Color.SLATE]
  } focus:ring-slate-500 hover:bg-slate-700`,
  [Color.STONE]: `${ColorVariants[Color.STONE]} ${
    ColorBorder[Color.STONE]
  } focus:ring-stone-500 hover:bg-stone-700`,
  [Color.TEAL]: `${ColorVariants[Color.TEAL]} ${
    ColorBorder[Color.TEAL]
  } focus:ring-teal-500 hover:bg-teal-700`,
  [Color.WHITE]: `${ColorVariants[Color.WHITE]} ${
    ColorBorder[Color.WHITE]
  } focus:ring-w-500 hover:bg-gray-50`,
  [Color.YELLOW]: `${ColorVariants[Color.YELLOW]} ${
    ColorBorder[Color.YELLOW]
  } focus:ring-yellow-500 hover:bg-yellow-600`,
  [Color.ZINC]: `${ColorVariants[Color.ZINC]} ${
    ColorBorder[Color.ZINC]
  } focus:ring-zinc-500 hover:bg-zinc-700`
};
